export default __webpack_public_path__ + "static/media/ILUSTRACIONES_01.16fabf3c.png";